import React, { useEffect, useState } from "react";
import { EstudioPaciente, ImagenPDF, Paciente, Usuario } from "../../interfaces";
import {
  IonAccordion,
  IonAccordionGroup,
  IonActionSheet,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonText,
  IonList,
  IonModal,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import StyledButton from "../StyledButton/StyledButton";
import dayjs from "dayjs";
import "dayjs/locale/es";
//@ts-ignore
import fileDownload from "js-file-download";
import CustomDesplegable from "../CustomDesplegable/CustomDesplegable";
import { cloudDownload, cloudDownloadOutline, eye, eyeOutline } from "ionicons/icons";
import { Document, Page, pdfjs } from "react-pdf";

import useNotificacion from "../../hooks/notificacion";
import { useSession } from "../../hooks/SessionContext";

import http from "../../hooks/httpAdapter";
import { useHistory } from "react-router";
require("dayjs/locale/es");

interface ContainerProps {
  abrirModal: boolean;
  setAbrirModal: (abrir: boolean) => void;
}
const ModalPdfsPaciente: React.FC<ContainerProps> = ({ abrirModal, setAbrirModal }) => {
  const [listadoEstudios, setListadoEstudios] = useState<ImagenPDF[]>([]);
  const [listadoEstudiosFiltrados, setListadoEstudiosFiltrados] = useState([]);
  const [estudioPdf, setEstudioPdf] = useState<ImagenPDF>();
  const [abrirModalPDF, setAbrirModalPDF] = useState(false);

  const { hcUL, cargandoSession, pacienteCargado, setSesionInvalida, mostrarNotificacion } =
    useSession();
  const history = useHistory();

  const TraerDocumentosPdf = async () => {
    let imagenes: ImagenPDF[] = [];
    const config = {
      headers: { Authorization: `Bearer ${hcUL?.token}` },
    };

    try {
      const response = await http()
        .get(`ImagenesPdf/${pacienteCargado?.codigo}`, config)
        .catch((e) => {
          if (e.response && e.response.status === 401) {
            setSesionInvalida(true);
            // history.push("/", { motivoRedireccion: "401" }); // Redirección en caso de error 401
          } else {
            console.error(e);
          }
        });
      if (response.length !== 0) {
        imagenes = response;
      }

      imagenes = imagenes.map((imagenPdf: ImagenPDF) => {
        return {
          ...imagenPdf,
          URLNombreArchivo: "./archivos/" + imagenPdf.nombreArchivo + ".pdf",
        };
      });

      setListadoEstudios(imagenes);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar las especialidades registradas",
        "rojo"
      );
    }
  };

  useEffect(() => {
    if (cargandoSession === false) {
      if (pacienteCargado !== null && pacienteCargado?.codigo !== 0 && abrirModal) {
        TraerDocumentosPdf();
      } else {
        mostrarNotificacion(true, "No se encuentra un paciente", "rojo");
      }
    }
  }, [pacienteCargado, cargandoSession]);

  const abrirCerrarModal = () => setAbrirModal(!abrirModal);

  const BuscarEstudio = async (estudio: ImagenPDF, pdfDoc: boolean, pdfUrl: boolean) => {
    try {
      const url = estudio.URLNombreArchivo;
      if (pdfDoc && !pdfUrl) {
        fileDownload(
          estudio.URLNombreArchivo || "",
          `${estudio.nombre}-${dayjs(dayjs()).format("YYYY-MM-DD")}.pdf`
        );
      } else {
        if (!pdfDoc && pdfUrl) {
          setEstudioPdf(estudio);
          abrirCerrarModal();
        }
      }
    } catch (error) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar buscar el estudio seleccionado",
        "rojo"
      );
    }

    return null;
  };

  const DescargarPdf = (estudio: ImagenPDF) => {
    if (estudio) {
      BuscarEstudio(estudio, true, false);
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
  };
  const VisualizarPdf = (estudio: ImagenPDF) => {
    if (estudio) {
      BuscarEstudio(estudio, false, true);
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
  };

  //cosas para el modalPDF
  const [numPages, setNumPages] = useState(null);
  //@ts-ignore
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <IonModal isOpen={abrirModal} onDidDismiss={() => setAbrirModal(false)}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Imagenes Pdf paciente</IonTitle>
          <StyledButton slot="end" fill="clear" expand="full" onClick={() => setAbrirModal(false)}>
            Salir
          </StyledButton>
        </IonToolbar>
      </IonHeader>
      {listadoEstudios.length <= 0 ? (
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol>
              <div className="ion-text-center">
                <p>No tiene estudios registrados</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : (
        <>
          <IonList lines="none">
            <IonGrid>
              <IonItem className="fila cabecera">
                <IonCol className="celda cabecera">
                  <p>Estudio</p>
                </IonCol>
              </IonItem>
              {listadoEstudiosFiltrados.map((fila: ImagenPDF) => (
                <IonItem key={fila.nombre} className="fila">
                  <IonCol className="celda">
                    <p>{dayjs(fila.nombreArchivo).format("YYYY-MM-DD")}</p>
                  </IonCol>
                  <IonCol className="celda" itemProp="">
                    <div className="iconColumn">
                      <IonButton shape="round" fill="clear" onClick={() => VisualizarPdf(fila)}>
                        <IonIcon size="large" ios={eyeOutline} md={eye} />
                      </IonButton>
                      <IonButton shape="round" fill="clear" onClick={() => DescargarPdf(fila)}>
                        <IonIcon size="large" ios={cloudDownloadOutline} md={cloudDownload} />
                      </IonButton>
                    </div>
                  </IonCol>
                </IonItem>
              ))}
            </IonGrid>
          </IonList>

          <IonActionSheet
            header={`${estudioPdf?.nombre}-${dayjs(dayjs()).format("YYYY-MM-DD")}`}
            buttons={[
              {
                text: "Cancelar",
                role: "cancel",
                data: {
                  action: "cancel",
                },
              },
            ]}
            onDidDismiss={abrirCerrarModal}
          >
            <IonContent className="ion-padding">
              {estudioPdf?.URLNombreArchivo && (
                <Document file={estudioPdf.URLNombreArchivo} onLoadSuccess={onDocumentLoadSuccess}>
                  {[...Array(numPages)].map((_, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={1} renderTextLayer={false} />
                  ))}
                </Document>
              )}
            </IonContent>
          </IonActionSheet>
          <IonModal isOpen={abrirModalPDF} backdropDismiss={false}>
            <IonHeader>
              <IonToolbar>
                <IonTitle>
                  {`${estudioPdf?.nombre}-${dayjs(dayjs()).format("YYYY-MM-DD")}`}
                </IonTitle>
                <IonButtons slot="end">
                  <IonButton strong={true} onClick={() => abrirCerrarModal()}>
                    Cerrar
                  </IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
              {estudioPdf?.URLNombreArchivo && (
                <Document file={estudioPdf.URLNombreArchivo} onLoadSuccess={onDocumentLoadSuccess}>
                  {[...Array(numPages)].map((_, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={1} renderTextLayer={false} />
                  ))}
                </Document>
              )}
            </IonContent>
          </IonModal>
        </>
      )}
    </IonModal>
  );
};

export default ModalPdfsPaciente;
